export const REQUEST_CROPS = "REQUEST_CROPS";
export const RECIEVE_CROPS = "RECIEVE_CROPS";

export const SET_SELECT_CROP = "SET_SELECT_CROP";
export const SET_SELECT_SEASON = "SET_SELECT_SEASON";
